import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
const initialState = {
  bannerData: null,
  addBtnLoading: false,
  bannerBtnLoading: false,
  deleteBtnLoading: false,
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BANNER:
      return updateObject(state, action.payload);
    case actionTypes.BANNER_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
